import staticWidget from './static';
import trackListWidget from './media/track-list';
import eventsCarouselWidget from './events-carousel';
import addressMapWidget from './address-map';

/**
 * Widget registry by `kind`. Unknown / not-yet-ported kinds render nothing.
 */
const registry = {
	static: staticWidget,
	'track-list': trackListWidget,
	'events-carousel': eventsCarouselWidget,
	'address-map': addressMapWidget
};

export default (node, ctx) => {
	const kind = node && node.kind;
	const render = kind && registry[kind];
	if (!render) {
		return [];
	}
	return render({node, ...ctx});
};
